(() => {
  "use strict";

  document.documentElement.classList.add("js-ready");

  const menu = document.querySelector("#site-menu");
  const menuButton = document.querySelector(".menu-toggle");
  const menuClose = menu?.querySelector(".menu-close");
  const closeMenu = () => {
    if (!menu?.open) return;
    menu.close();
    document.body.classList.remove("menu-open");
    menuButton?.setAttribute("aria-expanded", "false");
  };
  menuButton?.addEventListener("click", () => {
    menu.showModal();
    document.body.classList.add("menu-open");
    menuButton.setAttribute("aria-expanded", "true");
  });
  menuClose?.addEventListener("click", closeMenu);
  menu?.addEventListener("cancel", () => {
    document.body.classList.remove("menu-open");
    menuButton?.setAttribute("aria-expanded", "false");
  });
  menu?.addEventListener("click", (event) => {
    if (event.target === menu || event.target.closest("a[href^='#']")) closeMenu();
  });

  const tabs = [...document.querySelectorAll("[role='tab']")];
  const panels = [...document.querySelectorAll("[role='tabpanel']")];
  function activateTab(tab) {
    tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute("aria-selected", String(selected));
      item.dataset.state = selected ? "active" : "inactive";
      item.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((panel) => {
      const selected = panel.id === tab.getAttribute("aria-controls");
      panel.dataset.state = selected ? "active" : "inactive";
      panel.hidden = !selected;
    });
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => activateTab(tab));
    tab.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === "ArrowLeft") next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = tabs.length - 1;
      activateTab(tabs[next]);
      tabs[next].focus();
    });
  });
  const initiallySelected = tabs.find((tab) => tab.getAttribute("aria-selected") === "true") || tabs[0];
  if (initiallySelected) activateTab(initiallySelected);

  const cloudPanel = document.querySelector("#panel-cloud");
  document.querySelectorAll("input[name='billing']").forEach((input) => {
    input.addEventListener("change", () => {
      if (input.checked && cloudPanel) cloudPanel.dataset.billing = input.value;
    });
  });

  const journey = [
    { status: "Новая заявка", event: "Заявка с сайта добавлена", action: "Назначен ответственный", text: "Сайт, звонки и сообщения создают карточку клиента. История общения сохраняется в одном месте." },
    { status: "В работе", event: "Задача создана автоматически", action: "Подготовить предложение", text: "Менеджер получает задачу, клиент — ответ. Система напоминает о сроках и помогает довести сделку до оплаты." },
    { status: "Сделка завершена", event: "Сделка добавлена в отчёт", action: "Запланировать повторный контакт", text: "Воронка показывает, где находятся сделки. Можно оценивать конверсию, нагрузку и причины потерь." },
  ];
  const demoButton = document.querySelector("#demo-next");
  const columns = [...document.querySelectorAll(".pipeline-column")];
  const deal = document.querySelector(".moving-deal");
  let stage = 0;
  function updateDemo() {
    const state = journey[stage];
    columns.forEach((column, index) => {
      column.classList.toggle("is-current", index === stage);
      const count = column.querySelector(".column-label span:last-child");
      if (count) count.textContent = index === stage ? "1" : "0";
    });
    if (deal && columns[stage]) columns[stage].append(deal);
    const status = deal?.querySelector(".deal-person small");
    const action = deal?.querySelector(".deal-task");
    const event = document.querySelector(".crm-event > span:nth-child(2)");
    const caption = document.querySelector(".demo-caption");
    if (status) status.textContent = state.status;
    if (action) action.textContent = `✓ ${state.action}`;
    if (event) event.innerHTML = `${state.event}<small>Сценарий автоматизации</small>`;
    if (caption) caption.textContent = state.text;
    document.querySelectorAll(".demo-progress span").forEach((item, index) => item.classList.toggle("filled", index <= stage));
    const progress = document.querySelector(".demo-progress");
    progress?.setAttribute("aria-valuenow", String(stage + 1));
    progress?.setAttribute("aria-valuetext", `Этап ${stage + 1} из ${journey.length}`);
    if (demoButton) demoButton.textContent = stage === 2 ? "Ещё раз ↻" : "Провести заявку →";
    if (window.gsap && deal && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.gsap.fromTo(deal, { y: 14, opacity: .4 }, { y: 0, opacity: 1, duration: .45, ease: "power3.out" });
    }
  }
  let gsapLoadPromise;
  const loadGsap = () => {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (gsapLoadPromise) return gsapLoadPromise;
    gsapLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "assets/gsap.min.js?v=20260913";
      script.async = true;
      script.onload = () => resolve(window.gsap);
      script.onerror = reject;
      document.head.append(script);
    });
    return gsapLoadPromise;
  };

  demoButton?.addEventListener("click", async () => {
    try { await loadGsap(); } catch {}
    stage = (stage + 1) % journey.length;
    updateDemo();
  });

  document.querySelector("#brief-form")?.addEventListener("submit", (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const text = `Бриф на внедрение Битрикс24 — WEBCAT.PRO\n\nКомпания: ${data.get("company")}\nЗадача: ${data.get("task")}\n\nДокумент сформирован локально. Данные не отправлялись.`;
    const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = "WEBCAT-PRO-brief.txt";
    link.hidden = true;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    const note = event.currentTarget.querySelector(".form-note");
    if (note) note.textContent = "Бриф сохранён в файл. Данные не отправлялись.";
  });

  const webMcpContext = document.modelContext;
  if (webMcpContext?.registerTool) {
    const lifecycle = new AbortController();
    const registration = webMcpContext.registerTool({
      name: "prepare_bitrix24_implementation_brief",
      title: "Подготовить бриф на внедрение Битрикс24",
      description: "Заполняет видимую форму WEBCAT.PRO для проверки пользователем. Инструмент не отправляет данные и не скачивает файл.",
      inputSchema: {
        type: "object",
        properties: {
          company: { type: "string", minLength: 1, maxLength: 120, description: "Название компании клиента" },
          task: { type: "string", minLength: 1, maxLength: 3000, description: "Задача по внедрению или развитию Битрикс24" }
        },
        required: ["company", "task"],
        additionalProperties: false
      },
      annotations: {
        readOnlyHint: false,
        untrustedContentHint: true,
        consequentialHint: false
      },
      execute(input) {
        const company = typeof input?.company === "string" ? input.company.trim() : "";
        const task = typeof input?.task === "string" ? input.task.trim() : "";
        if (!company || company.length > 120) throw new TypeError("company must contain 1–120 characters");
        if (!task || task.length > 3000) throw new TypeError("task must contain 1–3000 characters");
        const form = document.querySelector("#brief-form");
        const companyField = form?.querySelector("[name='company']");
        const taskField = form?.querySelector("[name='task']");
        if (!form || !companyField || !taskField) throw new Error("Brief form is unavailable");
        companyField.value = company;
        taskField.value = task;
        for (const field of [companyField, taskField]) {
          field.dispatchEvent(new Event("input", { bubbles: true }));
          field.dispatchEvent(new Event("change", { bubbles: true }));
        }
        form.scrollIntoView({ behavior: "smooth", block: "center" });
        taskField.focus({ preventScroll: true });
        return {
          status: "ready_for_review",
          submitted: false,
          contact: {
            company: "WEBCAT.PRO",
            telephone: "+77783547398",
            salesEmail: "hello@webcat.pro",
            technicalEmail: "dev@webcat.pro",
            telegram: "https://t.me/dev_webcat"
          }
        };
      }
    }, { signal: lifecycle.signal });
    void Promise.resolve(registration).catch(() => {});
    window.addEventListener("pagehide", () => lifecycle.abort(), { once: true });
  }

  if (!matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const reveal = (element, delay = 0) => element.animate(
      [{ opacity: 0, transform: "translateY(24px)" }, { opacity: 1, transform: "translateY(0)" }],
      { duration: 650, delay, easing: "cubic-bezier(.22,1,.36,1)", fill: "both" }
    );
    document.querySelectorAll(".hero-reveal").forEach((element, index) => reveal(element, index * 70));
    const crmWindow = document.querySelector(".crm-window");
    if (crmWindow) reveal(crmWindow, 180);
    const observer = new IntersectionObserver((entries, currentObserver) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        currentObserver.unobserve(entry.target);
      }
    }, { rootMargin: "0px 0px -8%" });
    document.querySelectorAll("[data-reveal]").forEach((element) => observer.observe(element));
  }

  const flowHost = document.querySelector(".flow-lines");
  const initFlow = () => {
    if (!flowHost || flowHost.dataset.loaded === "true" || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    flowHost.dataset.loaded = "true";
    import("./assets/three.flow.min.js?v=20260913").then((THREE) => {
      let renderer;
      try { renderer = new THREE.WebGLRenderer({ alpha: true, antialias: false, powerPreference: "low-power" }); } catch { return; }
      renderer.setPixelRatio(Math.min(devicePixelRatio, 1.25));
      flowHost.append(renderer.domElement);
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(38, 1, .1, 30);
      camera.position.set(0, 0, 8);
      const group = new THREE.Group();
      scene.add(group);
      const routes = [];
      const packets = [];
      for (let i = 0; i < 5; i++) {
        const y = (i - 2) * .54;
        const curve = new THREE.CatmullRomCurve3([new THREE.Vector3(-3.8, y, 0), new THREE.Vector3(-1.5, y * .25, .4), new THREE.Vector3(.3, -.1, .8), new THREE.Vector3(3.5, y * .7, -.1)]);
        routes.push(curve);
        group.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(curve.getPoints(70)), new THREE.LineBasicMaterial({ color: 0x70ebff, transparent: true, opacity: .2 })));
        const packet = new THREE.Mesh(new THREE.SphereGeometry(.045, 8, 8), new THREE.MeshBasicMaterial({ color: i % 2 ? 0xffffff : 0xd6ff59 }));
        packets.push(packet);
        group.add(packet);
      }
      const resize = (width, height) => {
        if (!width || !height) return;
        renderer.setSize(width, height);
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
      };
      new ResizeObserver(([entry]) => resize(entry.contentRect.width, entry.contentRect.height)).observe(flowHost);
      const initialRect = flowHost.getBoundingClientRect();
      resize(initialRect.width, initialRect.height);
      let time = 0;
      let previous = performance.now();
      let lastFrame = 0;
      let visible = true;
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }).observe(flowHost);
      function animate(now) {
        requestAnimationFrame(animate);
        if (document.hidden || !visible || now - lastFrame < 42) { previous = now; return; }
        lastFrame = now;
        time += Math.min((now - previous) / 1000, .05);
        previous = now;
        packets.forEach((packet, i) => packet.position.copy(routes[i].getPointAt((time * .11 + i * .18 + stage * .14) % 1)));
        group.rotation.y = Math.sin(time * .12) * .06;
        renderer.render(scene, camera);
      }
      requestAnimationFrame(animate);
    }).catch(() => {});
  };
  if (flowHost) {
    for (const eventName of ["pointermove", "touchstart", "scroll", "keydown"]) {
      window.addEventListener(eventName, initFlow, { once: true, passive: true });
    }
  }
})();
